import { ShieldCheck, Droplets, FileCheck2 } from "lucide-react";
import AnimatedSection from "@/components/common/AnimatedSection";
import PageHero from "@/components/common/PageHero";
import PageTransition from "@/components/layout/PageTransition";

const measures = [
  {
    icon: ShieldCheck,
    title: "Clinical Sterilization Protocol",
    text: "Strict instrument sterilization cycles and surface disinfection with words best Class B Autoclaves MELAG",
  },
  {
    icon: Droplets,
    title: "Hygiene-First Environment",
    text: "Dedicated sanitation routines for treatment zones, waiting areas, and high-touch points throughout the day.",
  },
  {
    icon: FileCheck2,
    title: "Safety Documentation",
    text: "Process checklists and quality controls ensure every procedure follows safe, transparent standards.",
  },
];

export default function SafetyMeasuresPage() {
  return (
    <PageTransition testId="safety-measures-page">
      <PageHero
        title="Safety Measures"
        subtitle="High-standard sterilization, hygiene controls, and patient-first protocols at every stage of care."
        image="https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?auto=format&fit=crop&w=2000&q=80"
        testId="safety-measures-page-hero"
      />

      <div className="mx-auto max-w-7xl px-6 py-16 md:px-10 md:py-24">
        <AnimatedSection testId="safety-measures-cards-section">
          <div className="grid gap-6 md:grid-cols-3">
            {measures.map((item) => {
              const Icon = item.icon;
              return (
                <article
                  key={item.title}
                  className="rounded-2xl border border-[#f2e6c9] bg-white p-6"
                  data-testid={`safety-measure-card-${item.title
                    .toLowerCase()
                    .replace(/\s+/g, "-")}`}
                >
                  <Icon className="h-6 w-6 text-[#c5a059]" />
                  <h2
                    className="mt-3 font-[Playfair_Display] text-2xl text-[#1a1a1a]"
                    data-testid={`safety-measure-title-${item.title
                      .toLowerCase()
                      .replace(/\s+/g, "-")}`}
                  >
                    {item.title}
                  </h2>
                  <p
                    className="mt-3 font-[Manrope] text-sm text-[#555555]"
                    data-testid={`safety-measure-text-${item.title
                      .toLowerCase()
                      .replace(/\s+/g, "-")}`}
                  >
                    {item.text}
                  </p>
                </article>
              );
            })}
          </div>
        </AnimatedSection>
      </div>
    </PageTransition>
  );
}
